import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import ArticleNavigation from '../../../../components/layout/docs/ArticleNavigation';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import '../getting-started/HelpCategoryPage.css';

/**
 * Rewards Article Page
 */
const Rewards = () => {
  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-category-page">
        <div className="help-category-container">
          <main className="help-category-main">
            <div className="article-content">
              <header className="article-header">
                <h1 className="article-title">Rewards</h1>
                <p className="article-subtitle">
                  Welcome to the WeSplit reward ecosystem. Learn how to earn points through the 6-Season program, unlock badges, and what your points will be worth in the future.
                </p>
              </header>

              <div className="article-separator"></div>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">How It Works: The 6 Seasons</h2>
                  <p className="article-section-intro">
                    Every split, every invite, and every shared moment earns you Split Points. We are running a structured program of 6 Seasons leading up to our public launch and points conversion.
                  </p>
                </div>

                <div className="article-subsection">
                  <ul className="article-list-dots">
                    <li>
                      <strong>Unique Vibes:</strong> Each season comes with its own specific rules, bonuses, and surprises.
                    </li>
                    <li>
                      <strong>Early Bird Advantage:</strong> The earlier you join, the more you can stack. Jumping in at Season 1 gives you the maximum opportunity to level up before the final conversion.
                    </li>
                  </ul>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Utility: What are Split Points?</h2>
                  <p className="article-section-intro">
                    For now, Split Points are your primary way of leveling up your status within the WeSplit community.
                  </p>
                </div>

                <div className="article-subsection">
                  <ul className="article-list-dots">
                    <li>
                      <strong>Current Value:</strong> Points track your contribution and activity.
                    </li>
                    <li>
                      <strong>Future Perks:</strong> As the ecosystem grows, points will unlock access to premium features, fee reductions, a Point Shop, and exclusive advantages.
                    </li>
                    <li>
                      <strong>Potential Token:</strong> We are actively exploring ways for points to integrate into future ecosystem rewards, including a potential token model. If this path is chosen, our community will be the first to know.
                    </li>
                  </ul>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">How to Earn Points</h2>
                  <p className="article-section-intro">
                    There are multiple ways to stack points daily:
                  </p>
                </div>

                <div className="article-subsection">
                  <ol className="article-list">
                    <li>
                      <strong>Core Actions:</strong> Simply using the app—splitting bills, settling debts, and inviting friends—generates points.
                    </li>
                    <li>
                      <strong>Unique Quests:</strong> Complete specific, one-time challenges designed to help you explore the app's features.
                    </li>
                    <li>
                      <strong>Volume & Milestone Badges:</strong> Earn extra rewards for hitting specific milestones, such as a high number of transactions or total volume split.
                    </li>
                  </ol>
                </div>
              </section>

              <section className="article-section">
                <div className="article-subsection">
                  <h2 className="article-section-title">Event Rewards</h2>
                  <p className="article-section-intro">
                    WeSplit isn't just digital. When we participate in or organize real-life events (like hackathons, meetups, or conferences), you can claim Special Rewards. Keep an eye out for our team at events to unlock these exclusive bonuses.
                  </p>
                </div>
              </section>

              <div className="article-separator"></div>

              <LastUpdated />

              <ArticleNavigation
                previous={{
                  title: 'Gas Fees',
                  route: getHelpRoute(getHelpArticleRoute('features', 'gas-fees'))
                }}
                next={{
                  title: 'Groups',
                  route: getHelpRoute(getHelpArticleRoute('features', 'groups'))
                }}
              />
            </div>
          </main>
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Rewards;
